import axios from "axios";
import authHeader from "./auth-header";
import {API_URL} from "./api-uri";

const getCompany = () => {
  return axios
  .get(API_URL + "Company/1", { headers: authHeader() })
  .then((response) => {
    localStorage.setItem("Company", JSON.stringify(response.data));
    return response.data;
  });
};

const upsertCompany = (company) => {
  return axios
  .put(API_URL + "Company/" + company.id, company)
  .then((response) => {
    return response.data;
  });
};

export default {
    getCompany,upsertCompany
};